import { configureStore } from '@reduxjs/toolkit';
import { AppReducer } from '../AppReducer';
import { CarvingReducer } from '../Components/CarvingComponent/CarvingReducer';
import { HolidayReducer } from '../Components/HolidayComponent/HolidayReducer';
import { WeddingReducer } from '../Components/WeddingComponent/WeddingReducer';
import { GalleryReducer } from '../Components/GallerComponent/GalleryReducer';
import { PopupReducer } from '../Components/CommonPopup/PopupReducer';


export const store = configureStore({
  reducer: {
    app: AppReducer,
    carving: CarvingReducer,
    galReducer: GalleryReducer,
    holidayR: HolidayReducer,
    wedding: WeddingReducer,
    popup: PopupReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
